var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redis-dashboard",
    attrs: {
      "id": "redis-dashboard"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-section"
  }, [_c('div', {
    staticClass: "search-row"
  }, [_c('div', {
    staticClass: "search-group"
  }, [_c('label', [_vm._v("Search by Pattern")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyPattern),
      expression: "keyPattern"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e.g. user:*"
    },
    domProps: {
      "value": (_vm.keyPattern)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchKeysByPattern.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyPattern = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.fetchKeysByPattern
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Fetch by Pattern\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "search-group"
  }, [_c('label', [_vm._v("Search by Key Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exactKey),
      expression: "exactKey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e.g. user:1001"
    },
    domProps: {
      "value": (_vm.exactKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchKeyByName.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exactKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.fetchKeyByName
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Fetch by Name\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card results-card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [(_vm.redisKeys.length) ? _c('span', {
    staticClass: "result-count"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" " + _vm._s(_vm.redisKeys.length) + " key(s) found\n      ")]) : _c('span', {
    staticClass: "result-count text-muted"
  }, [_vm._v("No keys loaded")]), _vm._v(" "), (_vm.redisKeys.length) ? _c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    on: {
      "click": _vm.clearResults
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Clear\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(!_vm.redisKeys.length) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  }), _vm._v(" "), _c('p', [_vm._v("Search for keys using a pattern or exact key name above.")])]) : _vm._e(), _vm._v(" "), (_vm.redisKeys.length) ? _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.redisKeys), function(keyObj, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "key-cell",
      attrs: {
        "title": keyObj.key
      }
    }, [_vm._v(_vm._s(keyObj.key))]), _vm._v(" "), _c('td', {
      staticClass: "value-cell"
    }, [_c('div', {
      staticClass: "value-wrapper",
      class: {
        expanded: keyObj._expanded
      }
    }, [_c('pre', [_vm._v(_vm._s(_vm.formatValue(keyObj.value)))])]), _vm._v(" "), (_vm.isLongValue(keyObj.value)) ? _c('a', {
      staticClass: "toggle-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.toggleExpand(keyObj)
        }
      }
    }, [_vm._v("\n                " + _vm._s(keyObj._expanded ? 'Show less' : 'Show more') + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyObj.ttl_seconds))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyObj.expires_at || '-'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: keyObj.is_active ? 'badge-success' : 'badge-secondary'
    }, [_vm._v("\n                " + _vm._s(keyObj.is_active ? 'Yes' : 'No') + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "actions-cell"
    }, [_c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "title": "Update"
      },
      on: {
        "click": function($event) {
          return _vm.updateKey(keyObj)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteKey(keyObj.key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card danger-zone-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("This will permanently delete all keys matching the given pattern. This action cannot be undone.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purgePattern),
      expression: "purgePattern"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e.g. cache:temp:*"
    },
    domProps: {
      "value": (_vm.purgePattern)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.purgeKeys.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purgePattern = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.purgeKeys
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete by Pattern\n        ")])])])]), _vm._v(" "), (_vm.showUpdateModal == true) ? _c('b-modal', {
    attrs: {
      "title": "Confirmation",
      "size": "lg"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateModal = false
      }
    },
    model: {
      value: (_vm.showUpdateModal),
      callback: function($$v) {
        _vm.showUpdateModal = $$v
      },
      expression: "showUpdateModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Redis Key")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Key")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-key'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateKeyData.key),
      expression: "updateKeyData.key"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.updateKeyData.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.updateKeyData, "key", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Value")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-code'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateKeyData.value),
      expression: "updateKeyData.value"
    }],
    staticClass: "form-control",
    staticStyle: {
      "font-family": "monospace",
      "font-size": "13px"
    },
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.updateKeyData.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.updateKeyData, "value", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("TTL (seconds)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-clock-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.updateKeyData.ttl),
      expression: "updateKeyData.ttl",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "e.g. 3600"
    },
    domProps: {
      "value": (_vm.updateKeyData.ttl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.updateKeyData, "ttl", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmUpdateKey
    }
  }, [_vm._v("Update")]), _vm._v("  \n              "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateModal = false
      }
    }
  }, [_vm._v("Cancel")])])])])])])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-header"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v(" Redis Dashboard")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Key")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("Value")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("TTL (s)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Expires At")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Actions")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header danger-header"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Danger Zone — Delete Keys by Pattern\n    ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a9426c","hasScoped":true}!./src/views/components/RedisDashboard/RedisDashboard.html
// module id = 2043
// module chunks = 2